import angular from 'angular'
import intl from 'react-intl-universal'
import { getRevisionHistory } from '~/api/story'
import { storyLockedOrReadonlyAccessor } from '~/redux/appReducer'

import CONSTANTS from '~/constants'

function revisionsStandAloneController(
  $rootScope,
  $scope,
  $location,
  $window,
  $ngRedux,
  revisionHistoryService,
  padlockService,
  storyService,
  toastr,
  uiStateManagerService
) {
  // Used to clean up events.
  const toBeDestroyed = []
  this.revisionLoading = false
  this.revisions = []
  this.parentRevision = null
  this.storyId = null
  this.storyRevisionId = null
  this.branches = []
  this.selectedBranch = null

  this.reloadRevisionHistory = function () {
    this.revisionLoading = true

    Promise.all([this.getRevisionsForBranch()]).then((promiseValues) => {
      // Fallback for Pubstack, returns revisions array only
      this.revisions = promiseValues[0].data || promiseValues[0]

      for (let idx = 0; idx < this.revisions.length; idx++) {
        const revision = this.revisions[idx].revision
        if (this.storyObj.revision.parent_id === revision.parent_id) {
          this.parentRevision = this.revisions[idx]
        }
      }
      this.revisionLoading = false
    })
  }

  this.getBranchesForStory = function () {
    return revisionHistoryService
      .fetchBranchesForStory(this.storyId)
      .then((response) => {
        return response
      })
  }

  this.getRevisionsForBranch = () => {
    return revisionHistoryService
      .fetchRevisions(this.storyId, this.selectedBranch)
      .then((response) => {
        return response
      })
      .catch(() => {
        toastr.error(intl.get('ngRevisions.revisionListFailure'))
        this.revisionLoading = false
      })
  }

  const onStateChangeStateName = 'revisions'
  const onStateChangeWatch = function onStateChangeWatch(payload) {
    if (payload.state === 'active') {
      this.reloadRevisionHistory()

      document.getElementsByClassName('container scroll-v')[0].scrollTop = 0
    }
  }.bind(this)
  this.$onInit = () => {
    toBeDestroyed.push(
      uiStateManagerService.onStateChange(
        onStateChangeStateName,
        onStateChangeWatch
      )
    )
  }

  this.$onChanges = (changesObj) => {
    const newValue = changesObj.storyObj.currentValue
    if (angular.isDefined(newValue) && newValue._id) {
      this.storyId = newValue._id
      // padlock service returns false when non-stateful
      this.hasLock =
        padlockService.hasLock(newValue._id) ||
        !storyLockedOrReadonlyAccessor($ngRedux.getState())
      this.storyRevisionId = newValue.revision.revision_id
      this.currentRevisionId = newValue.diffViewRevisionId || null
      this.selectedBranch = newValue.revision.branch
      revisionHistoryService.flush()
    }
  }

  this.$onDestroy = () => {
    for (let idx = 0; idx < toBeDestroyed.length; idx++) {
      toBeDestroyed[idx]()
    }
  }

  this.restoreRevision = () => {
    storyService.restoreRevision(this.currentRevisionId)
  }

  this.getStoryUrl = function buildStoryRevisionUrl(
    storyId,
    branchId,
    revisionId,
    index,
    activeId
  ) {
    if (index === 0 || revisionId === activeId) {
      return null
    }

    /// branch/${branchId}
    const isLegacyEnabled = $rootScope.globalSettings?.openBeta?.legacyEnabled

    const redirectUrl = isLegacyEnabled
      ? `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_UI}/story/${storyId}/revision/${revisionId}`
      : `${CONSTANTS.TRIDENT_ROUTE_COMPOSER_UI}/story/${storyId}/revision/${revisionId}?allowAngular=true`

    return redirectUrl
  }

  this.setTab = function () {
    global.sessionStorage.setItem('set_tab', this.activeTab)
  }.bind(this)

  this.newBranchClicked = function () {
    this.createNewBranch({ newBranchName: this.newBranchName })
  }

  this.branchSelected = () => {
    $location.path(`/story/${this.storyId}/branch/${this.selectedBranch}`)
  }

  $scope.$on('SAVE_SUCCESS', (evt, details) => {
    this.storyId = details.story._id

    if (this.storyId) {
      this.reloadRevisionHistory()
    }
  })
}

export default [
  '$rootScope',
  '$scope',
  '$location',
  '$window',
  '$ngRedux',
  'revisionHistoryService',
  'padlockService',
  'storyService',
  'toastr',
  'uiStateManagerService',
  revisionsStandAloneController,
]
